import { vars } from '@/app/config/variables';

export class VideoSwitcher {
	readonly $video: HTMLVideoElement;
	protected mediaQuery: MediaQueryList;

	constructor(selector: HTMLVideoElement) {
		if (!selector) return;
		this.$video = selector;

		this.init();
	}

	public init(): void {
		this.mediaQuery = window.matchMedia(`(width <= ${vars.breakpoint.tablet}px)`);
		this.updateSources(this.mediaQuery.matches);
		this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
	}

	private updateSources(isMobile: boolean): void {
		const sources = this.$video.querySelectorAll<HTMLSourceElement>('source');

		sources.forEach((source) => {
			const desktopSrc = source.dataset.desktopSrc;
			const mobileSrc = source.dataset.mobileSrc;

			if (!desktopSrc || !mobileSrc) return;

			const nextSrc = isMobile ? mobileSrc : desktopSrc;

			if (source.src !== nextSrc) {
				source.src = nextSrc;
			}
		});

		this.reloadVideo();
	}

	private handleMediaQueryChange = ({ matches }: MediaQueryListEvent): void => {
		this.updateSources(matches);
	};

	private reloadVideo(): void {
		this.$video.load();
		this.$video.play().catch(() => {});
	}
}
